import styles from "../../styles/Components/header/MenuItem.module.css";

function MenuItem({ img, title, description, icon }) {
  return (
    <div className={`${styles.container} ${title === "Logout" ? styles.logout : ""}`}>
      {/*<img className={styles.icon} src={img} alt={title} />*/}
        <div className={styles.icon}>{icon}</div>
      <div
        className={`${
          title === "My Backtests" ? styles.insights : ""
        }`}
      >
        <h5 className={styles.title}>{title}</h5>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );
}

export default MenuItem;
